enum Status {
  Initialized,
  Idle,
  Loading,
}

export default Status;
